import { useState } from 'react'
import styled from 'styled-components'
import NormalTabs, { TabItemType } from '../../components/TabMenu/normal-tabs'
import { PoolInfo } from '../../hooks/usePoolInfo'
import { commify, formatUnits } from 'ethers/lib/utils'
import moment from 'moment'
import { STATICS } from '../../static'
import { BaseIGOInfo } from '../../types'
// import { transformToUTC } from '../../utils'

const menus: TabItemType[] = [
  { title: 'About the Project', id: 'about' },
  { title: 'Lottery Rules', id: 'rules' },
]

export default function About({ poolInfo, igoInfo }: { poolInfo: PoolInfo | null; igoInfo: BaseIGOInfo }) {
  const [tab, setTab] = useState(menus[0].id)

  // console.log(poolInfo)
  return (
    <AboutWrapper>
      <NormalTabs menus={menus} selected={tab} onChange={setTab} />
      {tab === 'about' && <BasicInformation baseInfo={igoInfo} poolInfo={poolInfo} />}
      {tab === 'signature' && <Signature />}
      {tab === 'rules' && <Rules />}
    </AboutWrapper>
  )
}

const AboutWrapper = styled.div`
  width: 1150px;
  min-height: 490px;
  background: #11388c;
  border-radius: 20px;
  margin-top: 30px;
  position: relative;
`

function BasicInformation({ baseInfo, poolInfo }: { baseInfo: BaseIGOInfo; poolInfo: PoolInfo | null }) {
  const social = baseInfo?.social_

  return (
    <BasicInformationWrapper>
      <Title>Basic Information</Title>
      <InfoWrapper>
        <InfoName>Name:</InfoName>
        {/* <InfoValue>{poolInfo?.targetToken.name}</InfoValue> */}
        <InfoValue>{baseInfo?.title}</InfoValue>
        <InfoName>Estimated amount sold:</InfoName>
        <InfoValue>
          {poolInfo
            ? `${commify(
                formatUnits(poolInfo.oneShareAmount.mul(poolInfo.totalShares), poolInfo.targetToken.decimals),
              )} ${poolInfo.targetToken.symbol}`
            : ''}
        </InfoValue>
        <InfoName>Selling period:</InfoName>
        <InfoValue>
          {poolInfo
            ? `${moment.unix(poolInfo.raisedStartTime).format('MMMM D,YYYY')} ~ ${moment
                .unix(poolInfo.raisedEndTime)
                .format('MMMM D,YYYY')}`
            : '----.--.-- ~ ----.--.--'}
        </InfoValue>
        <InfoName>Contract address:</InfoName>
        <InfoValue>{poolInfo?.targetToken.address}</InfoValue>
        {/* <InfoValue>{baseInfo?.sale_contract}</InfoValue> */}
        <InfoName>Social media:</InfoName>
        <InfoValue>
          <a href={baseInfo?.website} target={'_blank'} rel="noreferrer">
            <Icon src={STATICS.XNetwork} />
          </a>
          <a href={social?.[2].url} target={'_blank'} rel="noreferrer">
            <Icon src={STATICS.XTwitter} />
          </a>
          <a href={social?.[1].url} target={'_blank'} rel="noreferrer">
            <Icon src={STATICS.XTelegram} />
          </a>
          <a href={social?.[3].url} target={'_blank'} rel="noreferrer">
            <Icon src={STATICS.XDiscord} />
          </a>
        </InfoValue>
        <InfoName>Ecological chain</InfoName>
        <InfoValue>{baseInfo?.Chain.name}</InfoValue>
      </InfoWrapper>
      <Title style={{ marginTop: 46 }}>Program Information</Title>
      <Desc className="ql-editor" dangerouslySetInnerHTML={{ __html: baseInfo?.project_intro || '' }} />
    </BasicInformationWrapper>
  )
}

const BasicInformationWrapper = styled.div`
  padding: 37px 48px;
`
const Title = styled.h3`
  font-size: 18px;
  line-height: 25px;
  color: #ffffff;
  font-weight: 600;
`
const InfoWrapper = styled.div`
  width: 100%;
  height: auto;
  display: grid;
  margin-top: 22px;
  grid-template-columns: 126px 246px 240px auto;
  grid-row-gap: 18px;
`
const InfoName = styled.span`
  font-size: 14px;
  line-height: 20px;
  color: #6090f8;
`
const InfoValue = styled(InfoName)`
  color: #ffffff;
`

const Desc = styled.p`
  margin-top: 18px;
  font-size: 14px;
  line-height: 20px;
  color: #74a0ff;
`
const Icon = styled.img`
  width: 25px;
  height: 25px;
  border-radius: 50%;
  margin-right: 15px;
`

function Signature() {
  return (
    <SignatureWrapper>
      <Row>
        <span>
          Address&nbsp;<span style={{ color: '#FFFFFF' }}>(12000)</span>
        </span>
        <span>Level</span>
        <span>Probability of winning</span>
      </Row>
      <BodyRow>
        <span>0xghejkfhejklshf321321</span>
        <span>Level-1</span>
        <span>95.16%</span>
      </BodyRow>
      <BodyRow>
        <span>0xghejkfhejklshf321321</span>
        <span>Level-1</span>
        <span>95.16%</span>
      </BodyRow>
      <BodyRow>
        <span>0xghejkfhejklshf321321</span>
        <span>Level-1</span>
        <span>95.16%</span>
      </BodyRow>
      <BodyRow>
        <span>0xghejkfhejklshf321321</span>
        <span>Level-1</span>
        <span>95.16%</span>
      </BodyRow>
      <BodyRow>
        <span>0xghejkfhejklshf321321</span>
        <span>Level-1</span>
        <span>95.16%</span>
      </BodyRow>
      <BodyRow>
        <span>0xghejkfhejklshf321321</span>
        <span>Level-1</span>
        <span>95.16%</span>
      </BodyRow>
      <BodyRow>
        <span>0xghejkfhejklshf321321</span>
        <span>Level-1</span>
        <span>95.16%</span>
      </BodyRow>
      <BodyRow>
        <span>0xghejkfhejklshf321321</span>
        <span>Level-1</span>
        <span>95.16%</span>
      </BodyRow>
      <BodyRow>
        <span>0xghejkfhejklshf321321</span>
        <span>Level-1</span>
        <span>95.16%</span>
      </BodyRow>
      <BodyRow>
        <span>0xghejkfhejklshf321321</span>
        <span>Level-1</span>
        <span>95.16%</span>
      </BodyRow>
      <BodyRow>
        <span>0xghejkfhejklshf321321</span>
        <span>Level-1</span>
        <span>95.16%</span>
      </BodyRow>
      <BodyRow>
        <span>0xghejkfhejklshf321321</span>
        <span>Level-1</span>
        <span>95.16%</span>
      </BodyRow>
      <BodyRow>
        <span>0xghejkfhejklshf321321</span>
        <span>Level-1</span>
        <span>95.16%</span>
      </BodyRow>
      <BodyRow>
        <span>0xghejkfhejklshf321321</span>
        <span>Level-1</span>
        <span>95.16%</span>
      </BodyRow>
      <BodyRow>
        <span>0xghejkfhejklshf321321</span>
        <span>Level-1</span>
        <span>95.16%</span>
      </BodyRow>
      <BodyRow>
        <span>0xghejkfhejklshf321321</span>
        <span>Level-1</span>
        <span>95.16%</span>
      </BodyRow>
    </SignatureWrapper>
  )
}

const SignatureWrapper = styled.div`
  padding: 0 48px 0 48px;
  border-top: 20px solid transparent;
  border-bottom: 20px solid transparent;
  height: 456px;
  overflow: auto;
  width: calc(100% - 30px);
  ::-webkit-scrollbar {
    width: 4px;
    height: 1px;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 2px;
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    background: #2152bb;
    position: relative;
    left: -50px;
  }
  ::-webkit-scrollbar-track {
    border-radius: 2px;
    background: transparent;
  }
`
const Row = styled.div`
  display: grid;
  grid-template-columns: 457px 314px auto;
  font-size: 14px;
  color: #6090f8;
  line-height: 20px;
  height: 50px;
  align-items: center;
  justify-items: start;
  font-weight: 600;
`
const BodyRow = styled(Row)`
  color: #fff;
  font-weight: normal;
  box-shadow: 0px 1px 0px 0px #09438e;
`

function Rules() {
  return (
    <RulesWrapper>
      <Title>Rules for IGO Lottery Winning</Title>
      <Desc>
        ##IGOpool
        <br />
        Every IGO pool allocates rates for winning according to users’ VIP levels.
        <br />
        Rate of winning for each level
      </Desc>
      <Container>
        <Table>
          <TableRow>
            <span>Level</span>
            <span>Winning share</span>
          </TableRow>
          <TableBodyRow>
            <span>Vip-level-1</span>
            <span>5%</span>
          </TableBodyRow>
          <TableBodyRow>
            <span>Vip-level-2</span>
            <span>15%</span>
          </TableBodyRow>
          <TableBodyRow>
            <span>Vip-level-3</span>
            <span>30%</span>
          </TableBodyRow>
          <TableBodyRow>
            <span>Vip-level-4</span>
            <span>50%</span>
          </TableBodyRow>
        </Table>
        <RuleContent>
          <p>
            1. Cocos-BCX IGO is open for all COCOS members.
            <br />
            <br />
            2. Based on the shares that users purchased, the rules are as follows at the end of IGO:
            <br />
            • Shares less than IGO amount: 100% lottery winning rate for all users.
            <br />
            • Shares outnumber IGO amount: the winning rate varies according to the membership level. The higher level,
            the higher the winning rate.
            <br />
            <br />
            3. When the purchase ends, it's open for all users to claim the result in "My IGO" under the personal
            account page. The winners can claim the project token of the initial release at once. Users who miss out
            will get the principal back directly.
            <br />
            <br />
            4. IGO-Token Claim Rules
            <br />
            • Following the release rules, users can claim IGO token regularly on the Shares Claim History page with the
            release cycle.
            <br />
            <br />
            5. Users can view the progress of their purchased IGO projects in personal accounts.
            <br />
            <br />
            6. Users can view real-time membership status in personal accounts.
            <br />
            <br />
            7. The "rebase" before the lottery requires a snapshot of the user's membership status. Therefore
            participants can keep leveling up before IGO ends to enhance the winning rate. We suggest all participants
            not withdraw the COCOS and NFT staked which are used to get the computing power. It will lead to a downgrade
            of membership levels and a lower winning rate.
          </p>
        </RuleContent>
      </Container>
    </RulesWrapper>
  )
}

const RulesWrapper = styled.div`
  padding: 34px 52px;
  position: relative;
`
const Container = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 24px;
`
const Table = styled.div`
  width: 402px;
  background: #0d317d;
  border-radius: 12px;
  overflow: hidden;
  padding-bottom: 14px;
`
const TableRow = styled.div`
  height: 40px;
  padding: 0 20px;
  display: grid;
  grid-template-columns: 267px 100px;
  align-items: center;
  justify-items: start;
  font-size: 14px;
  color: #6090f8;
  line-height: 20px;
  background: #1a45a1;
`

const TableBodyRow = styled(TableRow)`
  color: #ffffff;
  background-color: #0d317d;
  border-bottom: solid 1px #1a449e;
  &:last-child {
    border-bottom-color: transparent;
  }
  span:last-child {
    color: #00f4e4;
  }
`

const RuleContent = styled.div`
  width: 634px;
  //height: 256px;
  background: #0d317d;
  border-radius: 12px;
  padding: 20px 42px 20px 26px;
  p {
    color: #74a0ff;
    font-size: 14px;
    line-height: 24px;
  }
`
